<i18n>
{
  "en": {
    "title": "Living Better & Sustainability 2017-2018",
    "description": "We value our sustainable and dynamic workforce. We believe in well-being as a way of life, emphasized this through Well-Being Labs, training, and more. Learn about our diverse teams and how we prioritize Diversity & Inclusion through a Diversity Advisory Board and initiatives including pay equity, Global Family Leave, and gender equity through programs like HeForShe.",
    "ourPeople": {
      "liveLives": {
        "hero": {
          "title": "We Live Our Lives Better"
        },
        "snapshot1": {
          "h2": "Well-being as a way of life",
          "p": "Well-being is a central part of who we are. Today's external pressures can make it difficult to strike a balance between personal and professional life. At Schneider, we aim to counteract that by creating an environment to help our employees better manage their energy across their unique lives.",
          "p2": "Well-Being Labs bring teams together to collaborate and proactively take care of their health through learning, events, and more. We set our employees up for success in managing their well-being, and by empowering our individual parts, the company becomes a stronger whole.",
          "c1": [
            "1,000",
            "",
            "Well-Being Labs across 50 countries in 2017, compared to 500 labs in 43 countries in 2016"
          ],
          "c2": "well-being trainings and learnings available to employees"
        },
        "txt1": {
          "h2": "Diversity means value",
          "p": "Diversity is the heritage and future of all Schneider Electric entities worldwide. At Schneider, diversity means value. It helps us boost innovation and find our competitive edge. Through our Diversity and Inclusion Policy, we prioritize tolerance, dignity, and respect, as well as gender equality, accelerating the development of women leaders across the company. We understand that it takes diverse teams to handle the diverse markets we serve. We support every employee’s individual development, welcoming them as they are, and ensuring that they have access to equal opportunities everywhere, around the world."
        },
        "barometer1": {
          "h2": "2015 – 2017 Planet <span class='t-nowrap'>& Society</span> barometer achievement",
          "cta": "See the full results",
          "indicator": {
            "title": "Health & Equity",
            "body": "reduction in the Medical Incident Rate (MIR)"
          }
        },
        "txt2": {
          "h2": "Global family leave",
          "p": [
            "We recognize and understand that each of us has a unique life and family situation, none like the other. Regardless of the details, our policies help support employees — no matter what they’re going through — to manage their situation as best as possible. That’s why we took an “all in” approach to our Global Family Leave Policy, an industry-leading initiative that launched in September 2017. It is all-inclusive, applying to all employees, globally, without exception.",
            "Schneider Electric provides fully paid parental, care, and bereavement leave in all countries. We have actively chosen to define “leave” and “family” in an inclusive way, recognizing that definition of family, life, and work are changing every day. By design, the policy includes key life stages for welcoming a new baby, taking care of sick or elderly family members, and mourning the loss of a family member. It also assumes an inclusive definition of family by extending an equal amount of parental leave to a parent by natural birth or adoption. The policy demonstrates a commitment to diversity and inclusion to generate greater engagement, performance, and innovation."
          ]
        },
        "quote": {
          "title": "SVP Talent and Diversity, Schneider Electric",
          "text": "It's great to see Schneider show, in concrete ways, its commitment to Diversity and Inclusion, and anchor it in a very pragmatic and personal policy that impacts lives."
        },
        "txt3": {
          "h2": "Measuring pay equity",
          "p": "As part of our Diversity and Inclusion ambition, gender pay equity was one of our top priorities for 2017. It touches every single employee, every single day. We’re holding ourselves accountable to make sure we have equal pay for equal work. Beyond equal pay, we’re making sure we have the right data and processes to avoid disparity in pay across equal roles, throughout the company — period."
        },
        "barometer2": {
          "h2": "2015 – 2017 Planet <span class='t-nowrap'>& Society</span> barometer achievement",
          "cta": "See the full results",
          "indicator": {
            "title": "Health & Equity",
            "body": "of employees work in countries with gender pay equity plans in place"
          }
        },
        "txt4": {
          "h2": "What HeForShe means here",
          "p": [
            "As part of its public commitment to gender equality, Schneider Electric participates in the U.N.’s HeForShe solidarity movement to promote gender equality. HeForShe encourages men to support change in favor of women’s rights and diversity. Schneider recently became a HeForShe IMPACT 10x10x10 Champion, signifying that it is one of 10 corporate champions for the HeForShe global solidarity movement.",
            "Initiated by U.N. Women, the campaign engages men and boys — including Schneider Chairman and CEO Jean-Pascal Tricoire — as advocates and agents of change for the achievement of gender equality and women’s rights."
          ]
        },
        "snapshot2": {
          "h2": "HeForShe Parity Report",
          "stat1": "38,000+",
          "c1": "Schneider Electric employees have joined the HeForShe Movement",
          "stat2": "23,000",
          "c2": "women recruited over the past three years"
        },
        "txt5": {
          "h2": "Diversity and Inclusion Advisory Board",
          "p": "In its second year, the Diversity and Inclusion Advisory Board came together to affect positive change for the entire company. The group continued to work diligently to advance gender diversity and foster a culture of inclusion within Schneider Electric. As thought leaders and innovators in their respective areas of expertise, they help create a unified voice for a more progressive Schneider."
        },
        "txt6": {
          "h2": "Racing toward gender equality",
          "p": "As the partner of the Marathon de Paris for the fifth year, Schneider Electric was proud to make great strides toward a greener and more gender-diverse event in 2017. The world’s second-largest marathon, the Schneider Electric Marathon de Paris welcomed 57,000 runners this year, 25% of whom were women."
        },
        "vidStart": {
          "title": "Changing Women's Lives",
          "desc": "Annette Clayton, <br>Executive Vice President, Supply Chain and North America Operations, Schneider Electric"
        }
      }
    }
  },
  "fr": {
    "title": "Living Better & Sustainability 2017-2018",
    "description": "We value our sustainable and dynamic workforce. We believe in well-being as a way of life, emphasized this through Well-Being Labs, training, and more. Learn about our diverse teams and how we prioritize Diversity & Inclusion through a Diversity Advisory Board and initiatives including pay equity, Global Family Leave, and gender equity through programs like HeForShe.",
    "ourPeople": {
      "liveLives": {
        "hero": {
          "title": "Mieux Vivre Nos Vies"
        },
        "snapshot1": {
          "h2": "Le bien-être comme art de vivre",
          "p": "Chez nous, le bien-être n’est pas uniquement quelque chose auquel nous aspirons ; c’est une composante essentielle de notre identité. Dans le monde actuel, les pressions externes font qu’il est plus compliqué que jamais de trouver un équilibre entre vie personnelle et vie professionnelle. Chez Schneider Electric nous souhaitons y remédier en instaurant un environnement dans lequel nos collaborateurs pourront mieux gérer leur énergie tout au long de leur vie.",
          "p2": "Nous guidons nos collaborateurs sur la voie du succès en nous préoccupant de leur bien-être. En prenant soin de chacun des éléments qui le composent, nous renforçons notre entreprise.",
          "c1": [
            "1 000",
            "Well-Being labs",
            "dans 50 pays en 2017, contre 500 labs dans 43 pays en 2016"
          ],
          "c2": "formations au bien-être destinées aux collaborateurs"
        },
        "txt1": {
          "h2": "La diversité, source de valeur",
          "p": "La diversité est à la fois l’héritage et l’avenir de toutes les entités Schneider Electric à travers le monde. Chez Schneider Electric, la diversité est source de valeur. Elle nous aide à doper l’innovation et à trouver des avantages compétitifs. À travers notre politique en faveur de la diversité et de l’inclusion, nous donnons la priorité à la tolérance, à la dignité et au respect, ainsi qu’à l'égalité hommes-femmes, en favorisant la promotion des femmes à des postes à responsabilité dans toute l’entreprise. Nous sommes conscients que, pour servir les divers marchés où nous sommes présents, nos équipes doivent elles-mêmes être diversifiées. Nous soutenons le développement personnel de tous nos collaborateurs, nous les acceptons tels qu’ils sont, et nous veillons à ce qu’ils aient accès aux mêmes chances partout dans le monde."
        },
        "barometer1": {
          "h2": "Résultat du baromètre 2015 &mdash; 2017 Planète & Société",
          "cta": "Voir l’ensemble des résultats",
          "indicator": {
            "title": "Santé & Équité",
            "body": "de réduction du Medical Incident Rate (MIR)"
          }
        },
        "txt2": {
          "h2": "Politique globale de congé familial",
          "p": [
            "Nous sommes conscients que la vie et la situation familiale de chacune et chacun d’entre nous est unique. Nos politiques visent à aider les collaborateurs à gérer leur situation au mieux, quelles que soient les circonstances. C’est pourquoi nous avons opté pour une approche cohérente dans la conception de notre politique globale de congé familial, initiative exemplaire lancée en septembre 2017. Cette politique inclusive s’applique à l’ensemble de nos collaborateurs à travers le monde, sans exception.",
            "Schneider Electric prévoit le maintien du salaire en cas d’arrêt d’activité dû à une naissance, un décès ou à la maladie grave d’un proche. Conscients de l’évolution constante des concepts de famille, de travail et de vie privée, nous avons volontairement retenu une définition élargie des termes « congé » et « famille ». Ainsi, tous les moments clés de la vie sont concernés : l’arrivée d’un nouvel enfant, la perte d’autonomie d’un proche malade ou fragilisé par l’âge et, le décès d’un membre de la famille. De même, il s’agit d’une politique parentale inclusive accordant un congé de même durée aux parents pour une naissance ou une adoption. Cette politique illustre l’engagement de Schneider Electric en faveur de la diversité et de l’inclusion, dans l'optique de stimuler l’engagement, la performance et l’innovation."
          ]
        },
        "quote": {
          "title": "SVP Talents et Diversité, Schneider Electric",
          "text": "Je trouve fantastique de voir Schneider Electric démontrer concrètement son engagement en faveur de la diversité et de l’inclusion, en l'ancrant dans une politique à la fois, pratique et très personnelle, qui fait une réelle différence dans la vie des collaborateurs."
        },
        "txt3": {
          "h2": "La mesure de l’équité salariale",
          "p": "Dans le cadre de notre ambition pour la diversité et l’inclusion, nous avons fait de l’équité salariale entre hommes et femmes l’une de nos priorités pour 2017. C’est une question qui touche tous les collaborateurs au quotidien. Nous mettons un point d'honneur à faire en sorte qu’à travail égal corresponde un salaire égal. Pour aller plus loin, nous nous assurons d’avoir les bonnes données et les bonnes méthodes afin d’éviter les disparités de salaire à niveau de responsabilité égal, et ce, à tous les échelons de l’entreprise – un point, c’est tout. Voici les progrès que nous avons réalisés jusqu’à présent :"
        },
        "barometer2": {
          "h2": "Résultat du baromètre 2015 &mdash; 2017 Planète & Société",
          "cta": "Voir l'ensemble des résultats",
          "indicator": {
            "title": "Santé & Équité",
            "body": "des collaborateurs travaillent dans des pays bénéficiant du plan Schneider Electric d’équité salariale"
          }
        },
        "txt4": {
          "h2": "L’importance de HeForShe pour Schneider Electric",
          "p": [
            "Dans le cadre de son engagement public en faveur de l'égalité entre les sexes, Schneider Electric participe au mouvement de solidarité en faveur de l’égalité hommes-femmes des Nations unies, HeForShe. HeForShe encourage les hommes à promouvoir le changement et à plaider en faveur des droits des femmes et de la diversité. Récemment, Schneider Electric est devenu un HeForShe Impact 10x10x10 Champion, c’est-à-dire l’une des 10 entreprises ambassadrices du mouvement de solidarité mondial HeForShe.",
            "Lancé par l'ONU Femmes, cette campagne vise à inciter les hommes de tous âges – dont le PDG de Schneider Electric, Jean-Pascal Tricoire – à devenir acteurs du changement et à promouvoir la mixité et les droits des femmes."
          ]
        },
        "snapshot2": {
          "h2": "Rapport sur l'initiative HeForShe",
          "stat1": "Plus de 38 000",
          "c1": "collaborateurs de Schneider Electric ont rejoint le mouvement HeForShe",
          "stat2": "23 000",
          "c2": "femmes recrutées ces trois dernières années"
        },
        "txt5": {
          "h2": "Le conseil consultatif pour la diversité et l’inclusion",
          "p": "Créé il y a deux ans, le conseil consultatif pour la diversité et l’inclusion a pour vocation de donner l’impulsion d'un changement positif dans l’ensemble de l’entreprise. Le Groupe a continué d’œuvrer pour faire avancer l’égalité entre les sexes et encourager une culture de l’inclusion au sein de Schneider Electric. Leaders d’opinion et pionniers dans leurs domaines d’expertise respectifs, les membres du conseil consultatif expriment collectivement le souhait de voir l'entreprise aller vers toujours plus de progrès et d’ouverture."
        },
        "txt6": {
          "h2": "Une course sous le signe de l’égalité",
          "p": "Partenaire du marathon de Paris pour la cinquième année, Schneider Electric est fier d’avoir accompli de grands progrès pour rendre cette manifestation plus écologique et plus mixte en 2017. Le Schneider Electric Paris Marathon est le deuxième plus grand marathon du monde, avec 57 000 coureurs inscrits cette année, dont 25 % de femmes."
        },
        "vidStart": {
          "title": "Changer la vie des femmes",
          "desc": "Annette Clayton, <br>Directeur général opérations industrielles et opérations Amérique du Nord, Schneider Electric"
        }
      }
    }
  }
}
</i18n>
<template>
  <div>
    <Hero
      :loResSrc="require('@/assets/img/our-people/our-people-we-live-hero-lowres.jpg')"
      :hiResSrc="require('@/assets/img/our-people/our-people-we-live-hero.jpg')"
      chapter="04"
      :section="$t('nav.OurPeople')"
      :title="$t('ourPeople.liveLives.hero.title')" />

      <section class="m-b-120 m-t-120">
        <YouTubeVideo videoId="LWlEaraDEZ8" :title="$t('ourPeople.liveLives.vidStart.title')" :description="$t('ourPeople.liveLives.vidStart.desc')" :preview="require('@/assets/img/thumbnails/SSDHighlightVideo_AnnetteClayton_Still.jpg')" />
      </section>

    <section class="m-t-120 l-section-pad l-bg-white">
      <TxtMedia>
        <div slot="main-content">
          <h2 class="m-b-35">{{$t('ourPeople.liveLives.snapshot1.h2')}}</h2>
          <p id="employeewellbeing">{{$t('ourPeople.liveLives.snapshot1.p')}}</p>
          <p>{{$t('ourPeople.liveLives.snapshot1.p2')}}</p>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/our-people/well-being.png')" alt="">
      </TxtMedia>
      <Snapshot>
        <SnapshotCard class="t-white" :double="true" :bgimg="require('@/assets/img/our-people/our-people-we-live-full-img1.jpg')">
          <h4>{{$t('ourPeople.liveLives.snapshot1.c1[0]')}}</h4>
          <p v-if="$i18n.locale === 'fr'" class="t-chartbody">{{$t('ourPeople.liveLives.snapshot1.c1[1]')}}</p>
          <div class="t-hr"></div>
          <p class="t-chartbody">{{$t('ourPeople.liveLives.snapshot1.c1[2]')}}</p>
        </SnapshotCard>
        <SnapshotCard class="t-white" :double="true" bgc="#3dcd58">
          <h4 class="">75</h4>
          <div class="t-hr t-hr--white"></div>
          <p>{{$t('ourPeople.liveLives.snapshot1.c2')}}</p>
        </SnapshotCard>
      </Snapshot>
    </section>

    <hr>

    <section class="m-b-120 l-section-pad l-bg-white">
      <TxtMedia>
        <h2 class="m-b-35" slot="main-content">{{$t('ourPeople.liveLives.txt1.h2')}}</h2>
        <p id="diversity" slot="main-content">{{$t('ourPeople.liveLives.txt1.p')}}</p>
        <img slot="sidebar" class="img-responsive"
          src="@/assets/img/our-people/our-people-we-live-diversity.jpg" alt="">
      </TxtMedia>
    </section>

    <section class="m-t-120 m-b-120">
      <Barometer>
        <h2 class="t-grey" slot="copy" v-html="$t('ourPeople.liveLives.barometer1.h2')"></h2>
        <CTA slot="copy" href="/static/PSBarometer-Q42017_results.pdf" :buttonText="$t('ourPeople.liveLives.barometer1.cta')" target="_blank" />
        <BarometerIndicator class="col-xs-18" color="#42b4e6"
          :title="$t('ourPeople.liveLives.barometer1.indicator.title')" stat="38%"
          :body="$t('ourPeople.liveLives.barometer1.indicator.body')"/>
      </Barometer>
    </section>

    <section class="m-t-120 l-section-pad l-bg-white">
      <TxtMedia>
        <div slot="main-content">
          <h2>{{$t('ourPeople.liveLives.txt2.h2')}}</h2>
          <p id="globalfamilyleave">{{$t('ourPeople.liveLives.txt2.p[0]')}}</p>
          <p>{{$t('ourPeople.liveLives.txt2.p[1]')}}</p>
        </div>
        <img slot="sidebar" src="@/assets/img/our-people/our-people-we-live-full-img2.jpg" alt="">
      </TxtMedia>
    </section>

    <section class="">
      <Quote name="Tina Mylon" :title="$t('ourPeople.liveLives.quote.title')"
        :photo="require('@/assets/img/our-people/our-people-we-live-quote.jpg')">
        <div v-html="$t('ourPeople.liveLives.quote.text')"></div>
      </Quote>
    </section>

    <section class="l-section-pad l-bg-white">
      <TxtMedia class="m-b-45">
        <div slot="main-content">
          <h2 class="m-b-35">{{$t('ourPeople.liveLives.txt3.h2')}}</h2>
          <p id="payequity">{{$t('ourPeople.liveLives.txt3.p')}}</p>
        </div>
        <img slot="sidebar" src="@/assets/img/our-people/LeonaWang.jpg" alt="">
      </TxtMedia>
    </section>

    <section class="m-t-120 m-b-120">
      <Barometer>
        <h2 class="t-grey" slot="copy" v-html="$t('ourPeople.liveLives.barometer2.h2')"></h2>
        <CTA slot="copy" href="/static/PSBarometer-Q42017_results.pdf" :buttonText="$t('ourPeople.liveLives.barometer2.cta')" target="_blank" />
        <BarometerIndicator class="col-xs-18" color="#42b4e6"
          :title="$t('ourPeople.liveLives.barometer2.indicator.title')" stat="85%"
          :body="$t('ourPeople.liveLives.barometer2.indicator.body')"/>
      </Barometer>
    </section>

    <section class="m-t-120 m-b-120 l-section-pad l-bg-white">
      <TxtMedia class="m-b-50">
        <h2 class="" slot="main-content">{{$t('ourPeople.liveLives.txt4.h2')}}</h2>
        <p id="heforshe" slot="main-content">{{$t('ourPeople.liveLives.txt4.p[0]')}}</p>
        <p slot="main-content">{{$t('ourPeople.liveLives.txt4.p[1]')}}</p>
        <img slot="sidebar" class="img-responsive"
          src="@/assets/img/our-people/our-people-we-live-heforshe.png" alt="">
      </TxtMedia>

      <hr>

      <Snapshot class="m-t-50">
        <div slot="above">
          <h2>{{$t('ourPeople.liveLives.snapshot2.h2')}}</h2>
        </div>
        <SnapshotCard class="t-white" :double="true" :bgc="$root.sassVars.cGreenLight">
          <h4>{{$t('ourPeople.liveLives.snapshot2.stat1')}}</h4>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody">{{$t('ourPeople.liveLives.snapshot2.c1')}}</p>
        </SnapshotCard>
        <SnapshotCard class="t-white" :double="true" :bgimg="require('@/assets/img/our-people/JohannesburgCanninah.jpg')">
          <h4>{{$t('ourPeople.liveLives.snapshot2.stat2')}}</h4>
          <div class="t-hr"></div>
          <p>{{$t('ourPeople.liveLives.snapshot2.c2')}}</p>
        </SnapshotCard>
      </Snapshot>
    </section>

    <section class="m-t-120 m-b-120">
      <TxtMedia id="diversity-means-value">
        <h2 class="m-b-35" slot="main-content">{{$t('ourPeople.liveLives.txt5.h2')}}</h2>
        <p slot="main-content">{{$t('ourPeople.liveLives.txt5.p')}}</p>
        <img slot="sidebar" class="img-responsive" alt=""
          src="@/assets/img/our-people/our-people-we-live-diversity-inclusion.jpg">
      </TxtMedia>
    </section>

    <section class="m-t-120 m-b-120">
      <TxtMedia>
        <div slot="main-content">
          <h2 class="m-b-35">{{$t('ourPeople.liveLives.txt6.h2')}}</h2>
          <p id="parismarathon">{{$t('ourPeople.liveLives.txt6.p')}}</p>
        </div>
          <img slot="sidebar" src="@/assets/img/our-people/our-people-we-live-full-img3.jpg" alt="">
      </TxtMedia>
    </section>

    <div class="l-content">
      <FooterNav
        nextRoute="Outreach_Overview"
        prevRoute="OurPeople_InvestmentForGrowth" />
    </div>
  </div>
</template>
<script>
import Hero from '@/components/Hero'
import FooterNav from '@/components/FooterNav'
import YouTubeVideo from '@/components/YouTubeVideo'
import Txt from '@/components/Txt'
import Snapshot from '@/components/Snapshot'
import SnapshotCard from '@/components/SnapshotCard'
import TxtMedia from '@/components/TxtMedia'
import Barometer from '@/components/Barometer'
import BarometerIndicator from '@/components/BarometerIndicator'
import CTA from '@/components/CTA'
import Quote from '@/components/Quote'
import ImageFull from '@/components/ImageFull'

export default {
  name: 'OurPeople_LiveLivesBetter',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    Hero,
    FooterNav,
    YouTubeVideo,
    Txt,
    Snapshot,
    SnapshotCard,
    TxtMedia,
    Barometer,
    BarometerIndicator,
    CTA,
    Quote,
    ImageFull
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/our-people/live-lives-better.vue